export const isSuccessRequest = ({ isError, isSuccess, data }, isBlob = false) => !isError && isSuccess && (isBlob || data?.success);
